/**
 * TerraMatrix brand color aliases -> hex values (from design tokens)
 * Canonical source - import from here instead of defining locally.
 */
export const BRAND_COLORS: Record<string, string> = {
  // Forest Green - Primary
  'forest green': '#4B633B',
  'forest': '#4B633B',
  'primary': '#4B633B',
  'brand': '#4B633B',
  'terramatrix': '#4B633B',

  // Sage Green - Secondary
  'sage green': '#B2AC88',
  'sage': '#B2AC88',
  'secondary': '#B2AC88',

  // Seafoam Green - Accent
  'seafoam': '#93E9BE',
  'seafoam green': '#93E9BE',
  'accent': '#93E9BE',

  // Blue Grotto - Info
  'blue grotto': '#116B98',
  'grotto': '#116B98',
  'info': '#116B98',
  'link': '#116B98',
  'tech': '#116B98',

  // Desert Sun - Warning
  'desert sun': '#E27D3D',
  'desert': '#E27D3D',
  'warning': '#E27D3D',
  'caution': '#E27D3D',

  // Chartreuse - Highlight
  'chartreuse': '#CCFF00',
  'highlight': '#CCFF00',
  'alert': '#CCFF00',

  // Charcoal - Primary text
  'charcoal': '#0A0A0A',
  'dark': '#0A0A0A',

  // Mid Gray
  'mid gray': '#6E6E6E',
  'mid grey': '#6E6E6E',
  'midgray': '#6E6E6E',
  'muted': '#6E6E6E',
  'subdued': '#6E6E6E',

  // Light Gray
  'light gray': '#F4F5F4',
  'light grey': '#F4F5F4',
  'lightgray': '#F4F5F4',
  'subtle': '#F4F5F4',

  // Champagne
  'champagne': '#F7E7CE',
  'cream': '#F7E7CE',
  'warm': '#F7E7CE',
};
